import React, { useState } from 'react';

const TruncatableText = ({
  text,
  maxLength = 100,
  className = '',
  style = {},
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxLength;
  const displayedText =
    expanded || !isLong ? text : text.slice(0, maxLength) + '...';

  return (
    <div
      style={{
        fontFamily: 'Inter',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '100%',
        letterSpacing: '0%',
        textTransform: 'capitalize',
      }}
    >
      {displayedText}
      {isLong && (
        <span
          onClick={() => setExpanded(!expanded)}
          style={{
            fontFamily: 'Inter',
            fontWeight: 400,
            fontSize: '16px',
            textTransform: 'capitalize',
            textDecoration: 'underline',
            textDecorationStyle: 'solid',
            cursor: 'pointer',
          }}
        >
          {expanded ? '...Read less' : 'Read more'}
        </span>
      )}
    </div>
  );
};

export default TruncatableText;
